// document.addEventListener("DOMContentLoaded", () => {
//   // Get references to the necessary HTML elements
//   const container = document.querySelector(
//     ".amthal-reviews .amthal-reviews-wrapper"
//   );
//   const reviews = document.querySelectorAll(
//     ".amthal-reviews .amthal-reviews-wrapper a"
//   );
//   const leftButton = document.querySelector(".reviews-prev");
//   const rightButton = document.querySelector(".reviews-next");
//
//   if (!container || !reviews || !leftButton || !rightButton) return;
//
//   leftButton.classList.add("disabled");
//
//   // Set the initial state
//   let currentIndex = 0;
//   const reviewWidth = reviews[0].offsetWidth;
//   const containerWidth = container.offsetWidth;
//   const reviewCount = reviews.length;
//   const reviewContainerWidth = reviewCount * reviewWidth;
//   let currentPosition = 0;
//
//   // Function to hide all reviews
//   function hideAllReviews() {
//     for (let i = 0; i < reviewCount; i++) {
//       reviews[i].style.transform = `translateX(${
//         currentPosition + (i - currentIndex) * reviewWidth
//       }px)`;
//     }
//   }
//
//   // Function to display the current review
//   function showCurrentReview() {
//     hideAllReviews();
//
//     // Add or remove class based on current index
//     if (currentIndex === 0) {
//       leftButton.classList.add("disabled");
//     } else {
//       leftButton.classList.remove("disabled");
//     }
//
//     if (currentIndex === reviewCount - 1) {
//       rightButton.classList.add("disabled");
//     } else {
//       rightButton.classList.remove("disabled");
//     }
//   }
//
//   // Function to navigate to the previous review
//   function navigateLeft(event) {
//     event.preventDefault();
//     if (currentIndex === 0) {
//       return; // Stop sliding when the first element is displayed
//     }
//     currentIndex = (currentIndex - 1 + reviewCount) % reviewCount;
//     currentPosition += reviewWidth;
//     showCurrentReview();
//   }
//
//   // Function to navigate to the next review
//   function navigateRight(event) {
//     event.preventDefault();
//     if (currentIndex === reviewCount - 1) {
//       return; // Stop sliding when the last element is displayed
//     }
//     currentIndex = (currentIndex + 1) % reviewCount;
//     currentPosition -= reviewWidth;
//     showCurrentReview();
//   }
//
//   // Add event listeners to the navigation buttons
//   leftButton.addEventListener("click", navigateLeft);
//   rightButton.addEventListener("click", navigateRight);
//
//   // Set the initial position of the reviews container
//   container.style.width = `${reviewContainerWidth}px`;
// });
//
// document.addEventListener("DOMContentLoaded", () => {
//   // Get references to the necessary HTML elements
//   const container = document.querySelector(
//     ".amthal-reviews .amthal-reviews-wrapper"
//   );
//   const reviews = document.querySelectorAll(
//     ".amthal-reviews .amthal-reviews-wrapper a"
//   );
//   const leftButton = document.querySelector(".reviews-prev");
//   const rightButton = document.querySelector(".reviews-next");
//
//   // Set the initial state
//   let currentIndex = 0;
//   const reviewWidth = reviews[0].offsetWidth;
//   const containerWidth = container.offsetWidth;
//   const reviewCount = reviews.length;
//   const reviewContainerWidth = reviewCount * reviewWidth;
//   let currentPosition = 0;
//   let targetPosition = 0;
//   let animationId = null;
//
//   // Function to hide all reviews
//   function hideAllReviews() {
//     for (let i = 0; i < reviewCount; i++) {
//       const position = (i - currentIndex) * reviewWidth;
//       const opacity = i === currentIndex ? 1 : 0;
//       reviews[i].style.transform = `translateX(${position}px)`;
//       // reviews[i].style.opacity = opacity;
//     }
//   }
//
//   // Function to animate the transition
//   function animate() {
//     const difference = targetPosition - currentPosition;
//     const easing = 0.1;
//     currentPosition += difference * easing;
//
//     if (Math.abs(difference) < 0.5) {
//       currentPosition = targetPosition;
//       cancelAnimationFrame(animationId);
//       animationId = null;
//     } else {
//       animationId = requestAnimationFrame(animate);
//     }
//
//     hideAllReviews();
//   }
//
//   // Function to display the current review
//   function showCurrentReview() {
//     hideAllReviews();
//     targetPosition = -currentIndex * reviewWidth;
//
//     if (!animationId) {
//       animate();
//     }
//
//     // Add or remove class based on current index
//     if (currentIndex === 0) {
//       leftButton.classList.add("disabled");
//     } else {
//       leftButton.classList.remove("disabled");
//     }
//
//     if (currentIndex === reviewCount - 1) {
//       rightButton.classList.add("disabled");
//     } else {
//       rightButton.classList.remove("disabled");
//     }
//   }
//
//   // Function to navigate to the previous review
//   function navigateLeft(event) {
//     event.preventDefault();
//     if (currentIndex === 0) {
//       return; // Stop sliding when the first element is displayed
//     }
//     currentIndex = (currentIndex - 1 + reviewCount) % reviewCount;
//     showCurrentReview();
//   }
//
//   // Function to navigate to the next review
//   function navigateRight(event) {
//     event.preventDefault();
//     if (currentIndex === reviewCount - 1) {
//       return; // Stop sliding when the last element is displayed
//     }
//     currentIndex = (currentIndex + 1) % reviewCount;
//     showCurrentReview();
//   }
//
//   // Add event listeners to the navigation buttons
//   leftButton.addEventListener("click", navigateLeft);
//   rightButton.addEventListener("click", navigateRight);
//
//   // Set the initial position of the reviews container
//   container.style.width = `${reviewContainerWidth}px`;
// });

document.addEventListener("DOMContentLoaded", () => {
  // Get references to the necessary HTML elements
  const container = document.querySelector(
    ".amthal-reviews .amthal-reviews-wrapper"
  );
  const reviews = document.querySelectorAll(
    ".amthal-reviews .amthal-reviews-wrapper a"
  );
  const leftButton = document.querySelector(".reviews-prev");
  const rightButton = document.querySelector(".reviews-next");

  if (!container || !reviews || !leftButton || !rightButton) return;

  leftButton.classList.add("disabled");

  // Set the initial state
  let currentIndex = 0;
  const reviewWidth = reviews[0].offsetWidth;
  const containerWidth = container.offsetWidth;
  const reviewCount = reviews.length;
  const reviewContainerWidth = reviewCount * reviewWidth;
  let currentPosition = 0;
  let targetPosition = 0;
  let animationId = null;

  // Function to hide all reviews
  function hideAllReviews() {
    container.style.transform = `translateX(${currentPosition}px)`;
  }

  // Function to animate the transition
  function animate() {
    const difference = targetPosition - currentPosition;
    const easing = 0.1;
    currentPosition += difference * easing;

    if (Math.abs(difference) < 0.5) {
      currentPosition = targetPosition;
      cancelAnimationFrame(animationId);
      animationId = null;
    } else {
      animationId = requestAnimationFrame(animate);
    }

    hideAllReviews();
  }

  // Function to display the current review
  function showCurrentReview() {
    hideAllReviews();
    targetPosition = -currentIndex * reviewWidth;

    if (!animationId) {
      animate();
    }

    // Add or remove class based on current index
    if (currentIndex === 0) {
      leftButton.classList.add("disabled");
    } else {
      leftButton.classList.remove("disabled");
    }

    if (currentIndex === reviewCount - 1) {
      rightButton.classList.add("disabled");
    } else {
      rightButton.classList.remove("disabled");
    }
  }

  // Function to navigate to the previous review
  function navigateLeft(event) {
    event.preventDefault();
    if (currentIndex === 0) {
      return; // Stop sliding when the first element is displayed
    }
    currentIndex = (currentIndex - 1 + reviewCount) % reviewCount;
    showCurrentReview();
  }

  // Function to navigate to the next review
  function navigateRight(event) {
    event.preventDefault();
    if (currentIndex === reviewCount - 1) {
      return; // Stop sliding when the last element is displayed
    }
    currentIndex = (currentIndex + 1) % reviewCount;
    showCurrentReview();
  }

  // Add event listeners to the navigation buttons
  leftButton.addEventListener("click", navigateLeft);
  rightButton.addEventListener("click", navigateRight);

  // Set the initial position of the reviews container
  container.style.width = `${reviewContainerWidth}px`;
});
